import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs/operators'

@Injectable({ providedIn: 'root' })
export class AcompanhamentoProvider {

  baseUrl = environment.API_URL;
  constructor(public http: HttpClient) {

  }


  tratarConteudo(acompanhamento: any, participanteList: any[], responsavelList: any[]) {
    var parts: any[] = [];
    participanteList.forEach((part: { id: any; }) => {
      parts.push(part.id);
    });

    var resps: any[] = [];
    responsavelList.forEach((resp: { id: any; }) => {
      resps.push(resp.id);
    });

    var acomp: any = {};
    acomp.acompanhamento = acompanhamento.descricao;
    acomp.titulo = acompanhamento.titulo;
    acomp.restrito = acompanhamento.restrito;
    acomp.datahora = acompanhamento.dataHora_data + ' ' + acompanhamento.dataHora_hora + ':00';
    acomp.dataHoraFim = acompanhamento.dataHoraFim_data + ' ' + acompanhamento.dataHoraFim_hora + ':00';
    acomp.idAcompanhamentoOperacao = acompanhamento.idAcompanhamentoOperacao;
    acomp.idAcompanhamentoStatus = acompanhamento.idAcompanhamentoStatus;
    acomp.tipo = acompanhamento.tipo;

    return {
      'participantes': parts,
      'responsaveis': resps,
      'acompanhamento': acomp
    };

  }

  getAcompanhamentos(filtro: { idAcompanhamentoOperacao: any; idCategoria: any; tipo: any; }) {
    filtro.idAcompanhamentoOperacao = filtro.idAcompanhamentoOperacao == '0' ? null : filtro.idAcompanhamentoOperacao;
    filtro.idCategoria = filtro.idCategoria == '0' ? null : filtro.idCategoria;
    filtro.tipo = filtro.tipo == '0' ? null : filtro.tipo;
    return this.http.post<any>(this.baseUrl + '/acompanhamento/get-acompanhamentos', { filtro: filtro })
      .pipe(map(data => {
        return data;
      }));
  }

  getHistorico(filtro: { dataInicio: any; dataFim: any; filtroResponsavel: any; }) {
    return this.http.get<any>(this.baseUrl + '/acompanhamento/get-historico-pessoa', { params: { dataInicio: filtro.dataInicio, dataFim: filtro.dataFim, filtro: filtro.filtroResponsavel } })
      .pipe(map(data => {
        return data;
      }));
  }

  getHistoricoByIdPessoa(idPessoa: any) {
    return this.http.post<any>(this.baseUrl + '/acompanhamento/get-acompanhamentos-by-id-pessoa', { idPessoa: idPessoa })
      .pipe(map(data => {
        return data;
      }));
  }

  getDadosBasicos() {
    return this.http.get<any>(this.baseUrl + '/acompanhamento/get-dados-basicos')
      .pipe(map(data => {
        return data;
      }));
  }

  getStatusFinalizar() {
    return this.http.get<any>(this.baseUrl + '/acompanhamento/get-status-finalizar')
      .pipe(map(data => {
        return data;
      }));
  }

  getStatusReagendar() {
    return this.http.get<any>(this.baseUrl + '/acompanhamento/get-status-reagendar')
      .pipe(map(data => {
        return data;
      }));
  }

  validarHorarioResponsavel(dadosValidacao: any) {
    return this.http.post<any>(this.baseUrl + '/acompanhamento/validar-horario-responsavel', dadosValidacao)
      .pipe(map(data => {
        return data;
      }));
  }

  salvarAcompanhamento(acompanhamento: any, participantes: any, responsaveis: any) {
    return this.http.post<any>(this.baseUrl + '/acompanhamento/salvar-acompanhamento', { acompanhamento: acompanhamento, participantes: participantes, responsaveis: responsaveis })
      .pipe(map(data => {
        return data;
      }));
  }

  salvarAcompanhamentoDetalhes(acompanhamento: any) {
    return this.http.post<any>(this.baseUrl + '/acompanhamento/salvar-acompanhamento-detalhes', { acompanhamento: acompanhamento })
      .pipe(map(data => {
        return data;
      }));
  }

  salvarCompromissoDetalhes(acompanhamento: any) {
    return this.http.post<any>(this.baseUrl + '/acompanhamento/salvar-compromisso-detalhes', { acompanhamento: acompanhamento })
      .pipe(map(data => {
        return data;
      }));
  }

  salvarPessoa(idAcompanhamento: any, pessoas: any, isResponsavel: any) {
    return this.http.post<any>(this.baseUrl + '/acompanhamento/salvar-pessoas-acompanhamento', { idAcompanhamento: idAcompanhamento, pessoas: pessoas, isResponsavel: isResponsavel })
      .pipe(map(data => {
        return data;
      }));
  }

  finalizarAcompanhamento(idAcompanhamento: any, idAcompanhamentoStatus: any, descricao: any) {
    return this.http.post<any>(this.baseUrl + '/acompanhamento/finalizar-acompanhamento', { idAcompanhamento: idAcompanhamento, idAcompanhamentoStatus: idAcompanhamentoStatus, descricao: descricao })
      .pipe(map(data => {
        return data;
      }));
  }

  assumir(idAcompanhamento: any) {
    return this.http.post<any>(this.baseUrl + '/acompanhamento/assumir-acompanhamento', { idAcompanhamento: idAcompanhamento })
      .pipe(map(data => {
        return data;
      }));
  }

  reagendarAcompanhamento(acompanhamento: any) {
    return this.http.post<any>(this.baseUrl + '/acompanhamento/reagendar-acompanhamento', { acompanhamento: acompanhamento })
      .pipe(map(data => {
        return data;
      }));
  }

}
